<template lang="pug">
  BaseTable(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :table="table"
    :items="items"
    :meta="meta"
    :sort="sort"
    :page="page"
    :onDelete="onDelete"
    :toggleSort="toggleSort"
    :changePage="changePage"
  )
</template>

<script>
import BaseTable from '@/components/app/BaseTable'
import store from '@/store'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'FeedbackSubjectIndex',
  components: { BaseTable },
  data: vm => ({
    title: vm.$t('feedback.subject.title')
  }),
  computed: {
    ...mapState('feedbackSubject', ['routeKey', 'routes', 'table', 'items', 'meta', 'sort', 'page']),
    crumbs: vm => [
      { text: vm.$t('feedback.title'), to: { name: 'feedback.index' } },
      { text: vm.$t('feedback.subject.title') }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('feedbackSubject/fetchItems')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapMutations('feedbackSubject', ['SET_SORT', 'SET_PAGE']),
    async onDelete (id) {
      await store.dispatch('feedbackSubject/deleteItem', { id })
      await store.dispatch('feedbackSubject/fetchItems')
      this.$notify({ message: this.$t('forms.notify.deleted') })
    },
    async toggleSort (field) {
      this.SET_SORT(field)
      await store.dispatch('feedbackSubject/fetchItems')
    },
    async changePage (page) {
      this.SET_PAGE(page)
      await store.dispatch('feedbackSubject/fetchItems')
    }
  }
}
</script>
